"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as t } from "../../theme-variant-context.js";
import { vars as l } from "../../skins/skin-contract.css-mistica.js";
const a = (_param)=>{
    var { color: o, size: c = 24 } = _param, v = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const e = t(), h = o !== null && o !== void 0 ? o : e ? l.colors.inverse : l.colors.neutralHigh;
    return /* @__PURE__ */ s("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, v), {
        children: [
            /* @__PURE__ */ r("path", {
                fill: h,
                d: "M6.088 11.422H4.816v3.703h.84v-1.277h.597c.487 0 .824-.115 1.04-.359q.277-.306.277-.9c0-.394-.096-.68-.297-.865-.238-.22-.605-.302-1.185-.302m.482 1.652c-.11.101-.222.14-.493.14v.003h-.418v-1.182h.395c.26 0 .418.037.521.13.098.092.14.24.14.439q.001.324-.145.47M8.172 11.422h1.143c.703 0 1.17.11 1.479.417.297.292.45.754.45 1.42 0 .673-.145 1.138-.45 1.451-.278.283-.703.418-1.364.418H8.172zm1.997 2.759c.146-.216.196-.465.196-.922 0-.532-.081-.781-.26-.974-.168-.18-.418-.244-.83-.244h-.26v2.47h.358c.379 0 .65-.114.796-.33M11.889 11.422h2.442l-.064.61h-1.532v.9h1.213v.633h-1.213v1.56h-.846zM20.113 7.803l.003.003v-.003z"
            }),
            /* @__PURE__ */ r("path", {
                fill: h,
                d: "M21.794 7.912q.046.11.047.238v12.306c0 .75-.644 1.383-1.409 1.383H8.25c-.75 0-1.409-.647-1.409-1.383l.034-2.77h-2.3a2.427 2.427 0 0 1-2.42-2.427v-4.095a2.427 2.427 0 0 1 2.42-2.426h2.266V3.534c0-.726.673-1.384 1.41-1.384h7.414c.23 0 .445.087.61.244l5.3 5.132c.11.106.174.243.219.386m-1.362 12.712c.098 0 .194-.096.194-.168V9.02h-2.311c-1.014 0-1.891-.33-2.535-.952-.65-.628-.995-1.487-.995-2.482V3.37H8.25c-.073 0-.187.109-.193.168v5.201h6.364c1.336 0 2.42 1.09 2.42 2.426v4.095a2.427 2.427 0 0 1-2.42 2.426h-6.33l-.034 2.779c0 .05.1.16.193.16zM3.368 15.259c0 .667.54 1.21 1.207 1.21h9.846a1.21 1.21 0 0 0 1.207-1.21v-4.095c0-.666-.54-1.21-1.207-1.21H4.575a1.21 1.21 0 0 0-1.207 1.21zm16.745-7.456L16 3.82v1.764c0 .659.216 1.213.622 1.608.414.4.997.61 1.692.61z"
            })
        ]
    }));
}, f = a;
export { f as default };
